module.exports = __webpack_public_path__ + "img/f.045f9d1d.jpg";